import { useScrollReveal } from 'shared/hooks/useScrollReveal';

interface RevealItemProps {
  children: React.ReactNode;
  index?: number;
  animation?: 'fade' | 'float-up' | 'fade-image';
  /** @default 150 */
  staggerInterval?: number;
  className?: string;
}

export function RevealItem({
  children,
  index = 0,
  animation = 'float-up',
  staggerInterval = 200,
  className,
}: RevealItemProps) {
  const { ref, style } = useScrollReveal({
    animation,
    delay: index * staggerInterval,
  });

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  );
}

export type { RevealItemProps };
